import { billingClosureState } from "../utils/billingClosureState";
import { closureButtonClass } from "../utils/closureButtonStyle";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { TabPanel } from "../components/TabPanel";
import {
  MdBarChart,
  MdCheck,
  MdContactPhone,
  MdChevronLeft,
  MdChevronRight,
  MdEuroSymbol,
  MdPeople,
  MdOutlineBadge,
  MdCloudUpload,
} from "react-icons/md";
import { Button } from "../components/Button";
import useAxiosPrivate from "../hooks/useAxiosPrivate.js";
import { ConIncarico } from "./F24/ConIncarico";
import { SenzaIncarico } from "./F24/SenzaIncarico";
import api from "../api/api.js";
import { toast } from "react-toastify";
import moment from "moment";
import { MdReceiptLong, MdAssignment, MdTableChart } from "react-icons/md";
import { Zucchetti } from "./Parcellazione/Zucchetti.js";
import { Bpoint } from "./Parcellazione/Bpoint.js";
import { IIpay } from "./Parcellazione/IIpay.js";
import { BillingLines } from "./Parcellazione/BillingLines.js";
import { AltriAdempimenti } from "./Parcellazione/AltriAdempimenti.js";
import { Listini } from "./Parcellazione/Listini.js";
import { ReportSezione3 } from "./Parcellazione/ReportSezione3.js";
import { Forfait } from "./Parcellazione/Forfait.js";
import { ForfaitF24 } from "./Parcellazione/ForfaitF24.js";
import { SezioneUno } from "./Parcellazione/SezioneUno.js";
import { Cedolini } from "./Parcellazione/Cedolini.js";
import { Fatturazione } from "./Parcellazione/Fatturazione.js";
import { ImportFile } from "./Parcellazione/ImportFile.js";
import { knowAcces } from "../utils/utils.js";

export const Parcellazione = ({screenSize}) => {
const [searchParams, setSearchParams] = useSearchParams();
const currentMonth = moment(new Date()).format("YYYY-MM");
const initialMonth = /^\d{4}-\d{2}$/.test(searchParams.get("mese") || "")
  ? searchParams.get("mese")
  : currentMonth;
const initialTab = Number(searchParams.get("tab")) || 4;
const [today,setToday] = useState(initialMonth)
const [aziendeZucchetti,setAziendeZucchetti] = useState([]);
const [aziendeIipay,setAziendeIipay] = useState([]);
const [aziendeBpoint,setAziendeBpoint] = useState([]);
const [periodo, setPeriodo] = useState(null);
const [billingClosureTarget, setBillingClosureTarget] = useState(null);
const [periodoBusy, setPeriodoBusy] = useState("");

const isAdmin = knowAcces(["parc_admin"]);
const isAmministrazione = knowAcces(["parc_amministrazione"]);
const canSeeAllSections = isAdmin || isAmministrazione;
const canSeeBillingLines = knowAcces(["parc_admin", "parc_team_leader", "parc_paghe", "parc_assunzioni", "parc_consulente", "parc_amministrazione"]);
const canSeeCedolini = knowAcces(["parc_admin", "parc_team_leader", "parc_paghe", "parc_amministrazione"]);
const isTeamLeader = knowAcces(["parc_team_leader"]);
const tuttiTeamStorageKey = `parcellazione.tutti.${localStorage.getItem("username") || "utente"}`;
const [tuttiTeam, setTuttiTeam] = useState(() => localStorage.getItem(tuttiTeamStorageKey) === "true");

  useEffect(() => {
    localStorage.setItem(tuttiTeamStorageKey, String(tuttiTeam));
  }, [tuttiTeam, tuttiTeamStorageKey]);

  const [tab, setTab] = useState(initialTab);

  const baseTabs = [
    {
      icon: <MdTableChart size={30} className="tab-icon" />,
      text: "Listini",
      id: 7,
    },
    {
      icon: <MdAssignment size={30} className="tab-icon" />,
      text: "Altri adempimenti",
      id: 4,
    },
  ];

  const [tabs, setTabs] = useState(
    canSeeBillingLines
      ? [
          ...baseTabs.slice(0, 2),
          ...(canSeeCedolini ? [{ icon: <MdOutlineBadge size={30} className="tab-icon" />, text: "Cedolini", id: 12 }] : []),
          ...(canSeeAllSections ? [
            { icon: <MdPeople size={30} className="tab-icon" />, text: "Payroll", id: 11 },
            { icon: <MdEuroSymbol size={30} className="tab-icon" />, text: "Forfait", id: 9 },
            { icon: <MdEuroSymbol size={30} className="tab-icon" />, text: "Forfait F24", id: 10 },
            ...(isAdmin ? [{ icon: <MdCloudUpload size={30} className="tab-icon" />, text: "Import file", id: 14 }] : []),
            { icon: <MdReceiptLong size={30} className="tab-icon" />, text: "Fatturazione", id: 13 },
          ] : []),
        ]
      : baseTabs
  );

  const syncUrlState = (nextTab, nextMonth) => {
    const params = new URLSearchParams(searchParams);
    params.set("tab", String(nextTab));
    params.set("mese", nextMonth);
    setSearchParams(params, { replace: true });
  };

  const handleTabChange = (nextTab) => {
    setTab(nextTab);
    syncUrlState(nextTab, today);
  };

  const handleMonthChange = (nextMonth) => {
    setToday(nextMonth);
    syncUrlState(tab, nextMonth);
  };

  const handleMonthStep = (delta) => {
    handleMonthChange(moment(today, "YYYY-MM").add(delta, "month").format("YYYY-MM"));
  };

  const loadPeriodo = async (signal = null) => {
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(today)) return;
    const [anno, mese] = today.split("-").map(Number);
    try {
      const res = await api.get(`/billing/periods/${anno}/${mese}`, { signal });
      setPeriodo(res.data);
    } catch (error) {
      if (signal?.aborted || error?.code === "ERR_CANCELED") return;
      setPeriodo(null);
      toast.error("Errore caricamento stato mese");
    }
  };

  const loadAziende = async (signal = null) => {
    try {
      const az = await api.get(`/aziende/parcellazione`, {
        params: { data: today, username: localStorage.getItem("username") },
        signal,
      });
      setAziendeZucchetti(az.data.zucch)  //1 zucchetti
      setAziendeBpoint(az.data.bpoint)  //2 bpoint
      setAziendeIipay(az.data.iipay)  //3 iipay




    } catch (error) {
      if (signal?.aborted || error?.code === "ERR_CANCELED") return;
      toast.error("Errore durante il caricamento")
    }

  }

  const SEZIONI_CHIUDIBILI = {
    4: { sezione: "altri_adempimenti", flags: ["chiuso_sez3", "chiuso_sez3_bpoint"], flag: "chiuso_sez3", label: "Sez. 3" },
    12: { sezione: "cedolini", flags: ["chiuso_sez1", "chiuso_sez2"], label: "operatori Zucchetti/iiPay" },
  };
  const sezioneAttiva = SEZIONI_CHIUDIBILI[tab] || null;
  const closureState = billingClosureState(periodo, tab === 4 ? 'altri_adempimenti' : 'cedolini');
  const sezioneAttivaChiusa = tab === 4
    ? closureState.bpointClosed && closureState.ziClosed
    : Boolean(sezioneAttiva && closureState.ziClosed);
  const sezioneAttivaFatturazioneChiusa = sezioneAttivaChiusa && (tab === 4
    ? closureState.bpointInvoiceClosed || closureState.ziInvoiceClosed
    : closureState.ziInvoiceClosed);
  const riaperturaTitle = sezioneAttivaFatturazioneChiusa
    ? `Riapri prima in Fatturazione ${[closureState.ziInvoiceClosed && 'Zucchetti/iiPay', tab === 4 && closureState.bpointInvoiceClosed && 'BPoint'].filter(Boolean).join(' e ')}`
    : '';
  const sezioneAttivaBusyKey = sezioneAttiva?.flags?.join("-") || sezioneAttiva?.flag || "";

  const handleCloseSezione = async (target = sezioneAttiva) => {
    const sezioneAttiva = target;
    const sezioneAttivaChiusa = (target?.flags || [target?.flag]).every((flag) => Boolean(periodo?.[flag]));
    const sezioneAttivaBusyKey = target?.flags?.join("-") || target?.flag || "";
    if (!sezioneAttiva || !periodo?.id || sezioneAttivaChiusa) return;
    if (!window.confirm(`Chiudere la ${sezioneAttiva.label}? L'admin potrà continuare a modificare.`)) return;
    setPeriodoBusy(sezioneAttivaBusyKey);
    try {
      const res = await api.post(`/billing/periods/${periodo.id}/close`, { sezione: sezioneAttiva.sezione });
      setPeriodo(res.data.period || (sezioneAttiva.flags || [sezioneAttiva.flag]).reduce(
        (next, flag) => ({ ...next, [flag]: 1 }),
        { ...periodo, stato: periodo.stato === "aperto" ? "chiuso_parzialmente" : periodo.stato }
      ));
      toast.success(`${sezioneAttiva.label} chiusa`);
    } catch (err) {
      toast.error(err.response?.data?.message || `Errore chiusura ${sezioneAttiva.label}`);
    } finally {
      setPeriodoBusy("");
    }
  };

  const handleReopenSezione = async (target = sezioneAttiva) => {
    const sezioneAttiva = target;
    const sezioneAttivaChiusa = (target?.flags || [target?.flag]).every((flag) => Boolean(periodo?.[flag]));
    const sezioneAttivaBusyKey = target?.flags?.join("-") || target?.flag || "";
    if (!sezioneAttiva || !periodo?.id || !sezioneAttivaChiusa) return;
    if (!window.confirm(`Riaprire solo la ${sezioneAttiva.label}? Le altre sezioni resteranno chiuse.`)) return;
    setPeriodoBusy(sezioneAttivaBusyKey);
    try {
      const res = await api.post(`/billing/periods/${periodo.id}/reopen`, { sezione: sezioneAttiva.sezione });
      setPeriodo(res.data.period);
      toast.success(`${sezioneAttiva.label} riaperta`);
    } catch (err) {
      toast.error(err.response?.data?.message || `Errore riapertura ${sezioneAttiva.label}`);
    } finally {
      setPeriodoBusy("");
    }
  };

  const allAziende = [...aziendeZucchetti, ...aziendeBpoint, ...aziendeIipay]
    .filter((a, i, arr) => arr.findIndex((b) => b.codice_univoco === a.codice_univoco) === i)
    .sort((a, b) => a.ragione_sociale.localeCompare(b.ragione_sociale));

  const baseContent = [
    { child: <Zucchetti screenSize={screenSize} aziende={aziendeZucchetti} data={today} loadAziende={loadAziende} />, id: 1 },
    { child: <Bpoint screenSize={screenSize} aziende={aziendeBpoint}   data={today} loadAziende={loadAziende} />,    id: 2 },
    { child: <IIpay screenSize={screenSize} aziende={aziendeIipay}  data={today} loadAziende={loadAziende} />,       id: 3 },
    { child: <Listini aziende={allAziende} data={today} />,                                                        id: 7 },
    { child: <AltriAdempimenti key={`aa-${today}`} data={today} livePeriodo={periodo} onRealtimeChange={loadPeriodo} aziende={allAziende} onPeriodChange={setToday} tuttiTeam={tuttiTeam} onTuttiTeamChange={setTuttiTeam} showTuttiTeam={isTeamLeader} />, id: 4 },
    ...(canSeeCedolini ? [{ child: <Cedolini data={today} periodo={periodo} tuttiTeam={tuttiTeam} onTuttiTeamChange={setTuttiTeam} showTuttiTeam={isTeamLeader} roleReadOnly={isAmministrazione} onRealtimeChange={loadPeriodo} />, id: 12 }] : []),
    ...(canSeeAllSections ? [{ child: <SezioneUno key={`s1-${today}-${periodo?.stato}-${periodo?.chiuso_sez1}`} data={today} />, id: 11 }] : []),
  ];

  let content = canSeeBillingLines
      ? [
        ...baseContent,
        ...(canSeeAllSections ? [
          { child: <Forfait key={`forfait-${today}-${periodo?.chiuso_sez4}`} initialMonth={today} livePeriodo={periodo} embedded aziende={allAziende} roleReadOnly={isAmministrazione} />, id: 9 },
          { child: <ForfaitF24 key={`forfait-f24-${today}-${periodo?.chiuso_sez5}`} initialMonth={today} livePeriodo={periodo} embedded aziende={allAziende} roleReadOnly={isAmministrazione} />, id: 10 },
          ...(isAdmin ? [{ child: <ImportFile key={`import-file-${today}-${periodo?.chiuso_sez6}`} data={today} periodo={periodo} roleReadOnly={!isAdmin} onImported={(meseDestinazione) => { if (meseDestinazione === today) loadPeriodo(); }} />, id: 14 }] : []),
        ] : []),
        { child: <BillingLines key={`bl-${today}-${periodo?.stato}-${periodo?.chiuso_sez3}`} data={today} />, id: 5 },
        ...(canSeeAllSections ? [
          { child: <ReportSezione3 data={today} />, id: 8 },
          { child: <Fatturazione key={`fatturazione-${today}`} data={today} closureTarget={billingClosureTarget} onClosureChange={() => loadPeriodo()} />, id: 13 },
        ] : []),
      ]
    : baseContent;




  useEffect(() => {
    const controller = new AbortController();
    loadAziende(controller.signal);
    loadPeriodo(controller.signal);
    return () => controller.abort();
  },[today]);

  useEffect(() => {
    if (!tabs.some((item) => item.id === tab)) {
      const fallbackTab = tabs.some((item) => item.id === 4) ? 4 : tabs[0]?.id;
      if (fallbackTab) handleTabChange(fallbackTab);
    }
  }, [tabs, tab]);
  
  













  return (
    <>
    
      <div className="mx-auto w-full max-w-none page-container !mx-0 gap-4">
        <div className="el-container h-fit mb-4">
          <div className="grid w-full grid-cols-1 items-center gap-3 rounded-md px-4 py-3 xl:min-h-[64px] xl:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] xl:py-2">
            <div className="flex flex-wrap items-center justify-center gap-3 text-xl font-semibold xl:col-start-2">
              <span>Mese selezionato:</span>
              <button
                type="button"
                onClick={() => handleMonthStep(-1)}
                aria-label="Mese precedente"
                title="Mese precedente"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
              >
                <MdChevronLeft size={22} />
              </button>
              <input
                type="month"
                id="start"
                name="start"
                value={today}
                onChange={(e) => { handleMonthChange(e.target.value); }}
                className="text-base font-normal"
              />
              <button
                type="button"
                onClick={() => handleMonthStep(1)}
                aria-label="Mese successivo"
                title="Mese successivo"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700"
              >
                <MdChevronRight size={22} />
              </button>
            </div>
            {tab === 13 && <div ref={setBillingClosureTarget} className="flex min-w-0 flex-nowrap items-center [justify-content:safe_center] gap-1 overflow-x-auto py-0.5 xl:col-start-3 xl:[justify-content:safe_flex-end]" />}
            {isAdmin && sezioneAttiva && (
              <div className="flex min-w-0 flex-nowrap items-center [justify-content:safe_center] gap-1 overflow-x-auto py-0.5 text-xs xl:col-start-3 xl:[justify-content:safe_flex-end]">
                <button type="button"
                  onClick={() => sezioneAttivaChiusa ? handleReopenSezione() : handleCloseSezione()}
                  disabled={!periodo?.id || Boolean(periodoBusy) || sezioneAttivaFatturazioneChiusa}
                  title={riaperturaTitle}
                  className={closureButtonClass(sezioneAttivaChiusa)}>
                  {periodoBusy === sezioneAttivaBusyKey ? "Attendi..." : `${sezioneAttivaChiusa ? "Riapri" : "Chiudi"} ${sezioneAttiva.label}`}
                </button>
                {tab === 12 && <button type="button"
                  onClick={() => (periodo?.chiuso_sez0 ? handleReopenSezione : handleCloseSezione)({ sezione: "cedolini_bpoint", flag: "chiuso_sez0", label: "operatori BPoint" })}
                  disabled={!periodo?.id || Boolean(periodoBusy) || periodo?.bpoint_invoice_closed}
                  title={periodo?.bpoint_invoice_closed ? "Riapri tutto BPoint in Fatturazione prima degli operatori" : ""}
                  className={closureButtonClass(closureState.bpointClosed)}>
                  {periodoBusy === "chiuso_sez0" ? "Attendi..." : `${closureState.bpointClosed ? "Riapri" : "Chiudi"} operatori BPoint`}
                </button>}
              </div>
            )}
          </div>
        </div>
        <TabPanel tab={tab} setTab={handleTabChange} tabs={tabs} content={content} />


        {/*} <TabPanel tab={tab} setTab={setTab} tabs={tabs} content={content} />
    
       <div className="flex w-full min-h-fit justify-end">
        <Button
          className="success-button"
          text="salva"
          type="button"
          icon={<MdCheck className="button-icon" />}
          onClick={async () => {
            console.log("salva");
          }}
        />
      </div> */}
      </div>
    </>
  );
};
